import type {CommonProps} from './types';

const LeftArrowSmall = ({
  color = 'currentColor',
  size = 10,
  ...rest
}: CommonProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.75 5h-7.5M4.75 1.5L1.25 5l3.5 3.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LeftArrowSmall;
